/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.deal.plans.rpc.DealPlansRpc
 */

/**
 *  This class can be used as a response type in cases where no response is needed or
 *  where <code>void</code> might have been used in a REST-ful context.
 */

export let ComHubspotCrmPropertiesDefaultsOptionsDealplan;
(function (_ComHubspotCrmPropertiesDefaultsOptionsDealplan) {})(ComHubspotCrmPropertiesDefaultsOptionsDealplan || (ComHubspotCrmPropertiesDefaultsOptionsDealplan = {}));
export let ComHubspotCrmPropertiesDefaultsOptionsDealplanmilestone;
(function (_ComHubspotCrmPropertiesDefaultsOptionsDealplanmilestone) {})(ComHubspotCrmPropertiesDefaultsOptionsDealplanmilestone || (ComHubspotCrmPropertiesDefaultsOptionsDealplanmilestone = {}));
export const BuyerCandidateTypename = 'com.hubspot.deal.plans.models.rpc.BuyerCandidate';
export const BuyerCandidateDiscriminant = 'BUYER';
export const BuyerCandidateDiscriminantKey = 'ownerType';
export const BuyerOwnerTypename = 'com.hubspot.deal.plans.models.rpc.BuyerOwner';
export const BuyerOwnerDiscriminant = 'BUYER';
export const BuyerOwnerDiscriminantKey = 'ownerType';
export const CompanyCandidateTypename = 'com.hubspot.deal.plans.models.rpc.CompanyCandidate';
export const CompanyCandidateDiscriminant = 'COMPANY';
export const CompanyCandidateDiscriminantKey = 'ownerType';
export const CompanyOwnerTypename = 'com.hubspot.deal.plans.models.rpc.CompanyOwner';
export const CompanyOwnerDiscriminant = 'COMPANY';
export const CompanyOwnerDiscriminantKey = 'ownerType';
export const DealPlanBuyerTypename = 'com.hubspot.deal.plans.models.rpc.DealPlanBuyer';
export const DealPlanBuyerDiscriminant = 'BUYER';
export const DealPlanBuyerDiscriminantKey = 'ownerType';
export const DealPlanCompanyAssigneeTypename = 'com.hubspot.deal.plans.models.rpc.DealPlanCompanyAssignee';
export const DealPlanCompanyAssigneeDiscriminant = 'COMPANY';
export const DealPlanCompanyAssigneeDiscriminantKey = 'ownerType';
export const DealPlanSellerTypename = 'com.hubspot.deal.plans.models.rpc.DealPlanSeller';
export const DealPlanSellerDiscriminant = 'SELLER';
export const DealPlanSellerDiscriminantKey = 'ownerType';
export const MilestoneAssigneeDiscriminantKey = 'ownerType';
export const MilestoneOwnerDiscriminantKey = 'ownerType';
export const OwnerCandidateDiscriminantKey = 'ownerType';
export const SellerCandidateTypename = 'com.hubspot.deal.plans.models.rpc.SellerCandidate';
export const SellerCandidateDiscriminant = 'SELLER';
export const SellerCandidateDiscriminantKey = 'ownerType';
export const SellerOwnerTypename = 'com.hubspot.deal.plans.models.rpc.SellerOwner';
export const SellerOwnerDiscriminant = 'SELLER';
export const SellerOwnerDiscriminantKey = 'ownerType';
export const DealPlanDoneEventTypename = 'com.hubspot.deal.plans.models.rpc.ai.generation.DealPlanDoneEvent';
export const DealPlanDoneEventDiscriminant = 'DONE';
export const DealPlanDoneEventDiscriminantKey = 'eventType';
export const DealPlanErrorEventTypename = 'com.hubspot.deal.plans.models.rpc.ai.generation.DealPlanErrorEvent';
export const DealPlanErrorEventDiscriminant = 'ERROR';
export const DealPlanErrorEventDiscriminantKey = 'eventType';
export const DealPlanMilestoneEventTypename = 'com.hubspot.deal.plans.models.rpc.ai.generation.DealPlanMilestoneEvent';
export const DealPlanMilestoneEventDiscriminant = 'MILESTONE';
export const DealPlanMilestoneEventDiscriminantKey = 'eventType';
export const DealPlanStatusEventTypename = 'com.hubspot.deal.plans.models.rpc.ai.generation.DealPlanStatusEvent';
export const DealPlanStatusEventDiscriminant = 'STATUS';
export const DealPlanStatusEventDiscriminantKey = 'eventType';
export const GenerateDealPlanEventIFDiscriminantKey = 'eventType';
export const createDealPlanRpc = {
  serviceName: 'com.hubspot.deal.plans.rpc.DealPlansRpc',
  rpcName: 'createDealPlan',
  auth: 'app',
  fingerprint: 'FCZMjvNUPblzaUVJGnMnrAnMjhu8G_1E',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getDealPlanRpc = {
  serviceName: 'com.hubspot.deal.plans.rpc.DealPlansRpc',
  rpcName: 'getDealPlan',
  auth: 'app',
  fingerprint: 'C-pe3d-NLaFqytPKVSUG_wnMjhu8G_1E',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const addBuyerRpc = {
  serviceName: 'com.hubspot.deal.plans.rpc.DealPlansRpc',
  rpcName: 'addBuyer',
  auth: 'app',
  fingerprint: 'E8Eqrkq6ew_WZkwEOR4AZQnMjhu8G_1E',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateDealPlanRpc = {
  serviceName: 'com.hubspot.deal.plans.rpc.DealPlansRpc',
  rpcName: 'updateDealPlan',
  auth: 'app',
  fingerprint: 'XpSRJd-WYh28xvhOezhHPQnMjhu8G_1E',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const createMilestoneRpc = {
  serviceName: 'com.hubspot.deal.plans.rpc.DealPlansRpc',
  rpcName: 'createMilestone',
  auth: 'app',
  fingerprint: 'N4Epotb1HarO7iwff1O-IwnMjhu8G_1E',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateMilestoneRpc = {
  serviceName: 'com.hubspot.deal.plans.rpc.DealPlansRpc',
  rpcName: 'updateMilestone',
  auth: 'app',
  fingerprint: 'i73Bepl-Fni-b8XwmE85XwnMjhu8G_1E',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const deleteMilestoneRpc = {
  serviceName: 'com.hubspot.deal.plans.rpc.DealPlansRpc',
  rpcName: 'deleteMilestone',
  auth: 'app',
  fingerprint: 'QXNLlPPrg7CWMYaa0T4skwnMjhu8G_1E',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const deleteDealPlanRpc = {
  serviceName: 'com.hubspot.deal.plans.rpc.DealPlansRpc',
  rpcName: 'deleteDealPlan',
  auth: 'app',
  fingerprint: '7a7uImIuh5wCe7LHApicJAnMjhu8G_1E',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getOwnerCandidatesRpc = {
  serviceName: 'com.hubspot.deal.plans.rpc.DealPlansRpc',
  rpcName: 'getOwnerCandidates',
  auth: 'app',
  fingerprint: 'T9AJiV1gdTWEaGZhXjR2fQnMjhu8G_1E',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const isDealPlanCardVisibleRpc = {
  serviceName: 'com.hubspot.deal.plans.rpc.DealPlansRpc',
  rpcName: 'isDealPlanCardVisible',
  auth: 'app',
  fingerprint: 'shesSmMR5TAAkGb-jE1bBgnMjhu8G_1E',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const deleteAllDealPlansRpc = {
  serviceName: 'com.hubspot.deal.plans.rpc.DealPlansRpc',
  rpcName: 'deleteAllDealPlans',
  auth: 'app',
  fingerprint: 'AAAAAAAAAACOUe2e_r4XmQnMjhu8G_1E',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const generateDealPlanRpc = {
  serviceName: 'com.hubspot.deal.plans.rpc.DealPlansRpc',
  rpcName: 'generateDealPlan',
  auth: 'app',
  fingerprint: 'cwYoAz8Pg8AMyRhy-usBugnMjhu8G_1E',
  na1Only: false,
  isStreaming: true,
  isHublessAppAuth: false
};